import { Config } from "@/types/Config";
import React, { createContext, useContext, useState, ReactNode, useEffect } from "react";

interface ConfigContextType {
  config: Config;
  setConfig: (config: Config) => void;
}

const ConfigContext = createContext<ConfigContextType | undefined>(undefined);

interface ConfigProviderProps {
  children: ReactNode;
  initialConfig: Config | any;
}

export const ClientConfigProvider = ({
  children,
  initialConfig,
}: ConfigProviderProps) => {
  const [config, setConfig] = useState<Config>(initialConfig);
//  useEffect(() => {
//     if (!config) {
//       import("@/data/config.json")
//         .then((mod) => setConfig(mod.default))
//         .catch((err) => console.error("Failed to load config:", err));
//     }
//   }, [config]);

//   if (!config) return null; 
  return (
    <ConfigContext.Provider value={{ config, setConfig }}>
      {children}
    </ConfigContext.Provider>
  );
};

export const useConfig = () => {
  const context = useContext(ConfigContext);
  if (!context) {
    throw new Error("useConfig must be used within a ConfigProvider");
  }
  return context;
};
